import React, { Component } from "react";
import { BrowserRouter, Switch, Route, withRouter } from "react-router-dom";
import TopBar from "./menus/TopBar";
import Home from "./views/Home";
import About from "./views/About";
import Contact from "./views/Contact";
import ScrollToTop from "./components/ScrollToTop";

class Routers extends React.Component {
  render() {
    return (
      <Route
        render={({ location }) => {
          return (
            <Switch location={location}>
              <Route exact path="/" component={Home} />
              <Route path="/about" component={About} />
              <Route path="/contact" component={Contact} />
            </Switch>
          );
        }}
      />
    );
  }
}

const WrapRouters = withRouter(Routers);

class App extends Component {
  render() {
    const SiteContainer = ({ links, location }) => (
      <div className="container full_height">
        <Route
          render={({ location }) => {
            return <WrapRouters />;
          }}
        />
      </div>
    );

    return (
      <BrowserRouter>
        <ScrollToTop />
        <div>
          <useLocation>
            {({ useLocation }) => {
              if (useLocation.pathname !== "/") {
                return <TopBar />;
              }
            }}
          </useLocation>

          <Switch>
            <Route component={SiteContainer} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
